import { render } from "./SelectScreenSize.vue?vue&type=template&id=a9429ea8"
import script from "./SelectScreenSize.vue?vue&type=script&lang=js"
export * from "./SelectScreenSize.vue?vue&type=script&lang=js"
script.render = render

export default script